export default {
	init() {
		this.$refs.wrapper.querySelectorAll('.post--rating').forEach(post => {
			post.addEventListener('click', () => {
				post.removeAttribute('unanswered');
			});
			post.setAttribute('unanswered', true);
		});
	},
	destroy() {},
	positionUpdated() {},
};
